:host {
  display: block;
}

a {
	color: var(--color-link-blue);
	text-decoration: none;
	font-weight: var(--font-weight-bold);
}
a:hover {
	color: var(--color-cwru-blue);
	text-decoration: underline;
}

.address-full {
	/* margin-bottom: 1em; */
}

.address-full address {
	font-weight: normal;
	text-decoration: none;
	font-style: normal;
	padding-bottom: 1em;
	line-height: 1.5;
}

.address-full p, .phone-full p, .email-full p, .site-feedback-full p {
	margin: 0;
}

p.contact {
	font-weight: var(--font-weight-semibold);
}
